import { createUseLocales } from '@planitgeo/treeplotter-i18n';
import { allLangs, defaultLang } from './config';

const useLocales = createUseLocales({ allLangs, defaultLang });

export default useLocales;
